(function() {
    "use strict";

    if (Backbone.Marionette) {
        Backbone.Marionette.TemplateCache.prototype.compileTemplate = function(rawTemplate) {
            return Handlebars.compile(rawTemplate);
        };
    }

    if (window.Handlebars) {
        window.Handlebars.registerHelper('select', function( value, options ){
            var $el = $('<select />').html( options.fn(this) );
            $el.find('[value="' + value + '"]').attr({'selected':'selected'});
            return $el.html();
        });
    }
}());



/*****************
 ** WEBPACK FOOTER
 ** ./js/vendor/backbone.marionette.handlebars.js
 ** module id = 1225
 ** module chunks = 10
 **/